//MENU HAMBURGER
const btn = document.querySelector(".btn--menu");
const menu = document.querySelector(".menu");

btn.addEventListener("click", (e) => {
    menu.classList.toggle("visible");
    btn.classList.toggle("open");
});

const li = document.querySelectorAll('.nav__el');
li.forEach((element) => {
	element.addEventListener('click', function() {
		menu.classList.remove("visible");
		btn.classList.remove("open");
	});
});

//TRANSITION DE PAGE
const link = document.querySelectorAll(".btn");
const page = document.querySelector("#anim");

link.forEach((element) =>{
	element.addEventListener("click", function(e){

		//récupérer le href, stocker
		const currentLink = this.href;

		//ajouter class .animation au body
		page.classList.add("animation");

		//animation end du body
		page.addEventListener("animationend", function(){

			//active le lien (changement de page)
			window.location = currentLink;
			
		});

		e.preventDefault(); //un lien qui ne lien plus


	});
});